import React from "react";
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';

// PDF Document Component with Inline Styles
const RequestDetailsPDF = ({ data, images }) => {
  // Get status colors based on status value
  const getStatusColors = (status) => {
    switch(status) {
      case 'Completed':
        return { bg: '#d4edda', border: '#28a745', text: '#155724' };
      case 'Pending':
        return { bg: '#fff3cd', border: '#ffc107', text: '#856404' };
      case 'Rejected':
        return { bg: '#f8d7da', border: '#dc3545', text: '#721c24' };
      default:
        return { bg: '#fff3cd', border: '#ffc107', text: '#856404' };
    }
  };

  const statusColors = getStatusColors(data?.status);

  return (
    <Document>
      <Page size="A4" style={{
        padding: 30,
        fontSize: 9,
        fontFamily: 'Helvetica',
        backgroundColor: '#ffffff',
        position: 'relative',
      }}>
        {/* Enhanced Header */}
        <View style={{
          backgroundColor: '#2c3e50',
          marginHorizontal: -30,
          marginTop: -30,
          paddingVertical: 15,
          paddingHorizontal: 30,
          marginBottom: 10,
        }}>
          <Text style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#ffffff',
            marginBottom: 2,
            // letterSpacing: 0.5,
            textAlign: 'center',
          }}>USER CONTRACT FORM</Text>
          <View style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 5,
          }}>
            <View style={{ flexDirection: 'column' }}>
              <Text style={{
                fontSize: 8,
                color: '#bdc3c7',
                marginBottom: 2,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}>Generated On</Text>
              <Text style={{
                fontSize: 10,
                color: '#ecf0f1',
                fontWeight: 'bold',
              }}>{new Date().toLocaleDateString('en-GB')}</Text>
            </View>
            <View style={{ flexDirection: 'column' }}>
              <Text style={{
                fontSize: 8,
                color: '#bdc3c7',
                marginBottom: 2,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}>Time</Text>
              <Text style={{
                fontSize: 10,
                color: '#ecf0f1',
                fontWeight: 'bold',
              }}>{new Date().toLocaleTimeString('en-GB')}</Text>
            </View>
            <View style={{ flexDirection: 'column' }}>
              <Text style={{
                fontSize: 8,
                color: '#bdc3c7',
                marginBottom: 2,
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}>
                {data?.status === "Pending" && "PENDING"}
                {data?.status === "Completed" && "APPROVED"}
                {data?.status === "Rejected" && "REJECTED"}
              </Text>
              <Text style={{
                fontSize: 10,
                color: '#ecf0f1',
                fontWeight: 'bold',
              }}>{`${data?.updated_by?.account_id || "Admin"}`}</Text>
            </View>
          </View>
        </View>

        {/* Personal Information */}
        <View style={{
          marginBottom: 8,
          backgroundColor: '#ffffff',
          borderRadius: 3,
          borderWidth: 1,
          borderColor: '#e8e8e8',
          borderStyle: 'solid',
          overflow: 'hidden',
        }}>
          <View style={{
            backgroundColor: '#34495e',
            paddingVertical: 5,
            paddingHorizontal: 10,
            borderBottomWidth: 2,
            borderBottomColor: '#2c3e50',
            borderBottomStyle: 'solid',
          }}>
            <Text style={{
              fontSize: 11,
              fontWeight: 'bold',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}>Personal Information</Text>
          </View>
          <View style={{ padding: 8 }}>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#fafafa',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>First Name:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.first_name || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#ffffff',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Last Name:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.last_name || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#fafafa',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Email Address:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.email || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#ffffff',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Phone Number:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.country_code || '+971'} {data?.mobile || 'N/A'}</Text>
            </View>

            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#ffffff',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>POS Number:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.pos_number || 'N/A'}</Text>
            </View>
          </View>
        </View>

        {/* Business Information */}
        <View style={{
          marginBottom: 8,
          backgroundColor: '#ffffff',
          borderRadius: 3,
          borderWidth: 1,
          borderColor: '#e8e8e8',
          borderStyle: 'solid',
          overflow: 'hidden',
        }}>
          <View style={{
            backgroundColor: '#34495e',
            paddingVertical: 5,
            paddingHorizontal: 10,
            borderBottomWidth: 2,
            borderBottomColor: '#2c3e50',
            borderBottomStyle: 'solid',
          }}>
            <Text style={{
              fontSize: 11,
              fontWeight: 'bold',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}>Business Information</Text>
          </View>
          <View style={{ padding: 8 }}>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#fafafa',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>User Type:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>Retailer</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#ffffff',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Store Name:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.store_name || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#fafafa',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Area:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.area || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#ffffff',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Trade License No:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.trade_license_no || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#fafafa',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Contract Given By:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.referBy || 'N/A'}</Text>
            </View>
          </View>
        </View>

        {/* Bind User Information */}
        <View style={{
          marginBottom: 8,
          backgroundColor: '#ffffff',
          borderRadius: 3,
          borderWidth: 1,
          borderColor: '#e8e8e8',
          borderStyle: 'solid',
          overflow: 'hidden',
        }}>
          <View style={{
            backgroundColor: '#34495e',
            paddingVertical: 5,
            paddingHorizontal: 10,
            borderBottomWidth: 2,
            borderBottomColor: '#2c3e50',
            borderBottomStyle: 'solid',
          }}>
            <Text style={{
              fontSize: 11,
              fontWeight: 'bold',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}>Bind User Information</Text>
          </View>
          <View style={{ padding: 8 }}>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#fafafa',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Bind User Type:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.bind_person_id?.users_type || 'N/A'}</Text>
            </View>
            <View style={{
              flexDirection: 'row',
              marginBottom: 2,
              paddingVertical: 4,
              paddingHorizontal: 6,
              backgroundColor: '#ffffff',
              borderRadius: 2,
            }}>
              <Text style={{
                width: '42%',
                fontSize: 9,
                fontWeight: 'bold',
                color: '#2c3e50',
                paddingRight: 8,
              }}>Bind User Name:</Text>
              <Text style={{
                width: '58%',
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.2,
              }}>{data?.bind_person_id?.users_name || 'N/A'}</Text>
            </View>
          </View>
        </View>

        {/* Remarks */}
        {data?.remarks && (
          <View style={{
            marginBottom: 8,
            backgroundColor: '#ffffff',
            borderRadius: 3,
            borderWidth: 1,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            overflow: 'hidden',
          }}>
            <View style={{
              backgroundColor: '#34495e',
              paddingVertical: 5,
              paddingHorizontal: 10,
              borderBottomWidth: 2,
              borderBottomColor: '#2c3e50',
              borderBottomStyle: 'solid',
            }}>
              <Text style={{
                fontSize: 11,
                fontWeight: 'bold',
                color: '#ffffff',
                textTransform: 'uppercase',
                letterSpacing: 0.5,
              }}>Remarks</Text>
            </View>
            <View style={{ padding: 8 }}>
              <Text style={{
                fontSize: 9,
                color: '#34495e',
                lineHeight: 1.3,
                padding: 8,
                backgroundColor: '#f8f9fa',
                borderRadius: 2,
                borderLeftWidth: 3,
                borderLeftColor: '#3498db',
                borderLeftStyle: 'solid',
              }}>{data?.remarks}</Text>
            </View>
          </View>
        )}

        {/* Status */}
        <View style={{
          marginBottom: 8,
          backgroundColor: '#ffffff',
          borderRadius: 3,
          borderWidth: 1,
          borderColor: '#e8e8e8',
          borderStyle: 'solid',
          overflow: 'hidden',
        }}>
          <View style={{
            backgroundColor: '#34495e',
            paddingVertical: 5,
            paddingHorizontal: 10,
            borderBottomWidth: 2,
            borderBottomColor: '#2c3e50',
            borderBottomStyle: 'solid',
          }}>
            <Text style={{
              fontSize: 11,
              fontWeight: 'bold',
              color: '#ffffff',
              textTransform: 'uppercase',
              letterSpacing: 0.5,
            }}>REQUEST STATUS</Text>
          </View>
          <View style={{ padding: 8 }}>
            <Text style={{
              fontSize: 9,
              color: '#34495e',
              lineHeight: 1.3,
              padding: 8,
              backgroundColor: '#f8f9fa',
              borderRadius: 2,
              borderLeftWidth: 3,
              borderLeftColor: '#3498db',
              borderLeftStyle: 'solid',
            }}>{`Request is ${data?.status} by ${data?.updated_by?.account_id || "Admin"}`}</Text>
          </View>
        </View>

        {/* Enhanced Footer */}
        <View style={{
          position: 'absolute',
          bottom: 15,
          left: 30,
          right: 30,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: 8,
          borderTopWidth: 1,
          borderTopColor: '#e8e8e8',
          borderTopStyle: 'solid',
        }}>
          <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
            This is a system generated document | <Text style={{ fontSize: 7, color: '#2c3e50', fontWeight: 'bold' }}>CRM System</Text>
          </Text>
          <Text style={{ fontSize: 7, color: '#7f8c8d' }}>Page 1</Text>
        </View>
      </Page>

      {/* Enhanced Image Pages - Each document on a separate page */}
      {images?.tradeLicense && (
        <Page size="A4" style={{ padding: 30, backgroundColor: '#f8f9fa' }}>
          <View style={{
            backgroundColor: '#ffffff',
            borderRadius: 6,
            padding: 15,
            borderWidth: 2,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            marginBottom: 15,
          }}>
            <View style={{
              backgroundColor: '#34495e',
              marginHorizontal: -15,
              marginTop: -15,
              paddingVertical: 10,
              paddingHorizontal: 15,
              marginBottom: 15,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}>
              <Text style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
              }}>Trade License</Text>
            </View>
            <View style={{
              borderWidth: 2,
              borderColor: '#e8e8e8',
              borderStyle: 'solid',
              borderRadius: 3,
              padding: 8,
              backgroundColor: '#ffffff',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Image src={images.tradeLicense} style={{
                width: '100%',
                height: 'auto',
                maxHeight: 650,
                objectFit: 'contain',
              }} />
            </View>
          </View>
          <View style={{
            position: 'absolute',
            bottom: 15,
            left: 30,
            right: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 8,
            borderTopWidth: 1,
            borderTopColor: '#e8e8e8',
            borderTopStyle: 'solid',
          }}>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              Trade License Document | <Text style={{ fontSize: 7, color: '#2c3e50', fontWeight: 'bold' }}>{data?.first_name} {data?.last_name}</Text>
            </Text>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>Page 2</Text>
          </View>
        </Page>
      )}

      {images?.id_proof_front && (
        <Page size="A4" style={{ padding: 30, backgroundColor: '#f8f9fa' }}>
          <View style={{
            backgroundColor: '#ffffff',
            borderRadius: 6,
            padding: 15,
            borderWidth: 2,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            marginBottom: 15,
          }}>
            <View style={{
              backgroundColor: '#34495e',
              marginHorizontal: -15,
              marginTop: -15,
              paddingVertical: 10,
              paddingHorizontal: 15,
              marginBottom: 15,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}>
              <Text style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
              }}>ID Proof - Front</Text>
            </View>
            <View style={{
              borderWidth: 2,
              borderColor: '#e8e8e8',
              borderStyle: 'solid',
              borderRadius: 3,
              padding: 8,
              backgroundColor: '#ffffff',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Image src={images.id_proof_front} style={{
                width: '100%',
                height: 'auto',
                maxHeight: 650,
                objectFit: 'contain',
              }} />
            </View>
          </View>
          <View style={{
            position: 'absolute',
            bottom: 15,
            left: 30,
            right: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 8,
            borderTopWidth: 1,
            borderTopColor: '#e8e8e8',
            borderTopStyle: 'solid',
          }}>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              ID Proof Front | <Text style={{ fontSize: 7, color: '#2c3e50', fontWeight: 'bold' }}>{data?.first_name} {data?.last_name}</Text>
            </Text>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>Page {images?.tradeLicense ? '3' : '2'}</Text>
          </View>
        </Page>
      )}

      {images?.id_proof_back && (
        <Page size="A4" style={{ padding: 30, backgroundColor: '#f8f9fa' }}>
          <View style={{
            backgroundColor: '#ffffff',
            borderRadius: 6,
            padding: 15,
            borderWidth: 2,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            marginBottom: 15,
          }}>
            <View style={{
              backgroundColor: '#34495e',
              marginHorizontal: -15,
              marginTop: -15,
              paddingVertical: 10,
              paddingHorizontal: 15,
              marginBottom: 15,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}>
              <Text style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
              }}>ID Proof - Back</Text>
            </View>
            <View style={{
              borderWidth: 2,
              borderColor: '#e8e8e8',
              borderStyle: 'solid',
              borderRadius: 3,
              padding: 8,
              backgroundColor: '#ffffff',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Image src={images.id_proof_back} style={{
                width: '100%',
                height: 'auto',
                maxHeight: 650,
                objectFit: 'contain',
              }} />
            </View>
          </View>
          <View style={{
            position: 'absolute',
            bottom: 15,
            left: 30,
            right: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 8,
            borderTopWidth: 1,
            borderTopColor: '#e8e8e8',
            borderTopStyle: 'solid',
          }}>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              ID Proof Back | <Text style={{ fontSize: 7, color: '#2c3e50', fontWeight: 'bold' }}>{data?.first_name} {data?.last_name}</Text>
            </Text>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              Page {(images?.tradeLicense ? 1 : 0) + (images?.id_proof_front ? 1 : 0) + 2}
            </Text>
          </View>
        </Page>
      )}

      {images?.signature && (
        <Page size="A4" style={{ padding: 30, backgroundColor: '#f8f9fa' }}>
          <View style={{
            backgroundColor: '#ffffff',
            borderRadius: 6,
            padding: 15,
            borderWidth: 2,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            marginBottom: 15,
          }}>
            <View style={{
              backgroundColor: '#34495e',
              marginHorizontal: -15,
              marginTop: -15,
              paddingVertical: 10,
              paddingHorizontal: 15,
              marginBottom: 15,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}>
              <Text style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
              }}>Signature</Text>
            </View>
            <View style={{
              borderWidth: 2,
              borderColor: '#e8e8e8',
              borderStyle: 'solid',
              borderRadius: 3,
              padding: 8,
              backgroundColor: '#ffffff',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Image src={images.signature} style={{
                width: '100%',
                height: 'auto',
                maxHeight: 650,
                objectFit: 'contain',
              }} />
            </View>
          </View>
          <View style={{
            position: 'absolute',
            bottom: 15,
            left: 30,
            right: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 8,
            borderTopWidth: 1,
            borderTopColor: '#e8e8e8',
            borderTopStyle: 'solid',
          }}>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              Signature Document | <Text style={{ fontSize: 7, color: '#2c3e50', fontWeight: 'bold' }}>{data?.first_name} {data?.last_name}</Text>
            </Text>
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              Page {(images?.tradeLicense ? 1 : 0) + (images?.id_proof_front ? 1 : 0) + (images?.id_proof_back ? 1 : 0) + 2}
            </Text>
          </View>
        </Page>
      )}
      {images?.agent_signature && (
        <Page size="A4" style={{ padding: 30, backgroundColor: '#f8f9fa' }}>
          <View style={{
            backgroundColor: '#ffffff',
            borderRadius: 6,
            padding: 15,
            borderWidth: 2,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            marginBottom: 15,
          }}>
            <View style={{
              backgroundColor: '#34495e',
              marginHorizontal: -15,
              marginTop: -15,
              paddingVertical: 10,
              paddingHorizontal: 15,
              marginBottom: 15,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}>
              <Text style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
              }}>Field Officer Signature</Text>
            </View>
            <View style={{
              borderWidth: 2,
              borderColor: '#e8e8e8',
              borderStyle: 'solid',
              borderRadius: 3,
              padding: 8,
              backgroundColor: '#ffffff',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Image src={images.agent_signature} style={{
                width: '100%',
                height: 'auto',
                maxHeight: 650,
                objectFit: 'contain',
              }} />
            </View>
          </View>
          <View style={{
            position: 'absolute',
            bottom: 15,
            left: 30,
            right: 30,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 8,
            borderTopWidth: 1,
            borderTopColor: '#e8e8e8',
            borderTopStyle: 'solid',
          }}>
            {/* <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              Signature Document | <Text style={{ fontSize: 7, color: '#2c3e50', fontWeight: 'bold' }}>{data?.first_name} {data?.last_name}</Text>
            </Text> */}
            <Text style={{ fontSize: 7, color: '#7f8c8d' }}>
              Page {(images?.tradeLicense ? 1 : 0) + (images?.id_proof_front ? 1 : 0) + (images?.id_proof_back ? 1 : 0) + 2}
            </Text>
          </View>
        </Page>
      )}
      {images?.pos_image && (
        <Page size="A4" style={{ padding: 30, backgroundColor: '#f8f9fa' }}>
          <View style={{
            backgroundColor: '#ffffff',
            borderRadius: 6,
            padding: 15,
            borderWidth: 2,
            borderColor: '#e8e8e8',
            borderStyle: 'solid',
            marginBottom: 15,
          }}>
            <View style={{
              backgroundColor: '#34495e',
              marginHorizontal: -15,
              marginTop: -15,
              paddingVertical: 10,
              paddingHorizontal: 15,
              marginBottom: 15,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}>
              <Text style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#ffffff',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: 0.8,
              }}>POS Image</Text>
            </View>
            <View style={{
              borderWidth: 2,
              borderColor: '#e8e8e8',
              borderStyle: 'solid',
              borderRadius: 3,
              padding: 8,
              backgroundColor: '#ffffff',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Image src={images.pos_image} style={{
                width: '100%',
                height: 'auto',
                maxHeight: 650,
                objectFit: 'contain',
              }} />
            </View>
          </View>
        </Page>
      )}
    </Document>
  );
};

export default RequestDetailsPDF;

